import { useEffect, useState } from 'react';

import { VIEW_TYPES } from '../../components/organisms/navigation/shared/constants';

export const useDeviceType = () => {
  const [device, setDevice] = useState('');

  useEffect(() => {
    const userAgentString = navigator.userAgent;
    const matchMobile = userAgentString.match(
      /Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i
    );
    const matchTablet = userAgentString.match(/Tablet|iPad/i);

    if (matchMobile && !matchTablet) {
      setDevice(VIEW_TYPES.mobile);
    } else if (matchTablet || matchMobile) {
      setDevice(VIEW_TYPES.tablet);
    } else {
      setDevice(VIEW_TYPES.desktop);
    }
  }, []);

  return device;
};
